module.exports = __webpack_public_path__ + "static/media/PDF_file_icon.a37611af.svg";